import { z } from "zod";

export const BANNED_WORD_LOCALE_VALUES = ["fr", "en", "all"] as const;
export const BannedWordLocale = {
	FR: "fr",
	EN: "en",
	ALL: "all",
} as const;
export type BannedWordLocale = (typeof BANNED_WORD_LOCALE_VALUES)[number];

export const BANNED_WORD_SEVERITY_VALUES = ["mask", "block"] as const;
export const BannedWordSeverity = {
	MASK: "mask",
	BLOCK: "block",
} as const;
export type BannedWordSeverity = (typeof BANNED_WORD_SEVERITY_VALUES)[number];

export const bannedWordSchema = z.object({
	id: z.string(),
	word: z.string(),
	locale: z.enum(BANNED_WORD_LOCALE_VALUES),
	severity: z.enum(BANNED_WORD_SEVERITY_VALUES),
	created_by: z.string().nullable(),
	created_at: z.union([z.date(), z.string()]),
	updated_at: z.union([z.date(), z.string()]),
});
export type BannedWord = z.infer<typeof bannedWordSchema>;

export const createBannedWordSchema = z.object({
	word: z.string().trim().min(1).max(100),
	locale: z.enum(BANNED_WORD_LOCALE_VALUES).default("all"),
	severity: z.enum(BANNED_WORD_SEVERITY_VALUES).default("mask"),
});
export type CreateBannedWordPayload = z.infer<typeof createBannedWordSchema>;

export const updateBannedWordSchema = z.object({
	word: z.string().trim().min(1).max(100).optional(),
	locale: z.enum(BANNED_WORD_LOCALE_VALUES).optional(),
	severity: z.enum(BANNED_WORD_SEVERITY_VALUES).optional(),
});
export type UpdateBannedWordPayload = z.infer<typeof updateBannedWordSchema>;

export const listBannedWordsQuerySchema = z.object({
	limit: z.coerce.number().int().min(1).max(200).default(50),
	offset: z.coerce.number().int().min(0).default(0),
	locale: z.enum(BANNED_WORD_LOCALE_VALUES).optional(),
	severity: z.enum(BANNED_WORD_SEVERITY_VALUES).optional(),
	q: z.string().trim().max(100).optional(),
});
export type ListBannedWordsQuery = z.infer<typeof listBannedWordsQuerySchema>;

export const BANNED_WORD_REJECTED_ERROR_CODE = "content_rejected_by_banned_word" as const;
